import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { agency } from "../api";

export default function AgencyGeoLeaderboard() {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    agency.geoLeaderboard().then(setRows).catch((e) => setErr(e.message));
  }, []);

  if (err) return <div className="page"><div className="error-box">{err}</div></div>;
  if (!rows) return <div className="page"><p className="subtle">Loading…</p></div>;

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h1>GEO leaderboard</h1>
          <div className="subtle">How visible each client is in AI search, ranked.</div>
        </div>
      </div>

      {rows.length === 0 ? (
        <div className="empty">No GEO snapshots yet.</div>
      ) : (
        <div className="card">
          <table className="data">
            <thead>
              <tr><th>#</th><th>Client</th><th>Score</th><th>Points</th><th>Month</th></tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.client_id}>
                  <td>{i + 1}</td>
                  <td><Link to={`/clients/${r.client_id}`}>{r.client_name}</Link></td>
                  <td>{r.score_pct != null ? `${r.score_pct.toFixed(1)}%` : "—"}</td>
                  <td>{r.total_score != null ? `${r.total_score} / ${r.max_possible}` : "—"}</td>
                  <td>{r.month ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
